import { motion } from 'framer-motion';
import { useScrollReveal } from '../hooks/useScrollReveal';
import { fadeInUp } from '../utils/animations';
import { Calendar, GraduationCap, Award, Briefcase, Trophy } from 'lucide-react';

const Timeline = () => {
  const { ref, controls } = useScrollReveal(0.1);

  const timelineEvents = [
    {
      date: '2025년 10월',
      title: 'KERIS 2025 개인전 출전 수상',
      description: '제 11회 정보보안경진대회 개인전 4위',
      icon: Trophy,
    },
    {
      date: '2025년 10월',
      title: 'KERIS 2025 단체전 출전 수상',
      description: '제 11회 정보보안경진대회 단체전 2위',
      icon: Trophy,
    },
    {
      date: '2025년 11월',
      title: '2025 Layer7 출전 수상',
      description: '선린인고 Layer7 청소년부 1위',
      icon: Trophy,
    },
    {
      date: '2025년 11월',
      title: '목포대학교 정보보안영재교육원 수료',
      description: '정보보안영재원 심화과정 수료',
      icon: GraduationCap,
    },
    {
      date: '2025년 12월',
      title: '제 1회 감귤 CTF 수상',
      description: '감귤 CTF 청소년부 3위 https://dreamhack.io/ctf/766',
      icon: Trophy,
    },
    {
      date: '2026년 2월',
      title: '전남 남악중학교 졸업',
      description: '전남 남악중학교 졸업',
      icon: GraduationCap,
    },
    {
      date: '2026년 2월',
      title: '조코딩 x OpenAI x Primer AI 해커톤 출전',
      description: '조코딩 x OpenAI x Primer AI 해커톤 출전 (Gitfle) https://hack.primer.kr/rounds/8',
      icon: Trophy,
    },
    {
      date: '2026년 2월',
      title: 'Grizzly Hacks II 해커톤 수상',
      description: 'Grizzly Hacks II 해커톤 1위 수상 (BSD) https://grizzly-hacks-ii.devpost.com/',
      icon: Trophy,
    },
    {
      date: '2026년 3월',
      title: '선린인터넷고등학교 121기 재학',
      description: '선린인터넷고등학교 소프트웨어과 121기 재학',
      icon: GraduationCap,
    },
  ];
  
  return (
    <section id="timeline" className="py-20 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          ref={ref}
          initial="initial"
          animate={controls}
          variants={fadeInUp}
          className="text-center mb-16"
        >
          <h2 className="text-3xl sm:text-4xl font-bold text-neutral-800 mb-4">
            Timeline
          </h2>
          <p className="text-lg text-neutral-600">
            저의 성장 과정을 소개합니다.
          </p>
        </motion.div>

        {/* Timeline */}
        <div className="relative">
          {/* Vertical line */}
          <div className="absolute left-4 md:left-1/2 md:-translate-x-px top-0 bottom-0 w-0.5 bg-neutral-200" />

          {timelineEvents.map((event, index) => {
            const Icon = event.icon;
            const isEven = index % 2 === 0;

            return (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 30 }}
                animate={controls}
                variants={{
                  animate: { opacity: 1, y: 0 }
                }}
                transition={{ delay: index * 0.15, duration: 0.5 }}
                className={`relative flex items-center mb-12 ${
                  isEven ? 'md:flex-row' : 'md:flex-row-reverse'
                }`}
              >
                {/* Content */}
                <div className={`flex-1 ml-12 md:ml-0 ${isEven ? 'md:pr-12 md:text-right' : 'md:pl-12 md:text-left'}`}>
                  <div className="p-6">
                    <span className="inline-block text-sm font-medium text-neutral-500 mb-3">
                      {event.date}
                    </span>
                    <h3 className="text-xl font-bold text-neutral-800 mb-2">
                      {event.title}
                    </h3>
                    <p className="text-neutral-600">
                      {event.description}
                    </p>
                  </div>
                </div>

                {/* Icon */}
                <div className="absolute left-0 md:left-1/2 md:-translate-x-1/2 w-8 h-8 rounded-full bg-white border-2 border-neutral-300 flex items-center justify-center shadow-sm">
                  <Icon className="w-4 h-4 text-neutral-500" />
                </div>

                {/* Spacer for opposite side on desktop */}
                <div className="hidden md:block flex-1" />
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Timeline;
